<template>
	<v-container class="noMargin">
		<v-layout row wrap>					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>PRODUCTS SALES REPORTS</h2>					
				</div>				
				<v-btn @click.prevent="fncFilterProductSalesReports" class="elevation-5	" color="info"><i class="material-icons">filter_list</i>FILTER / GENERATE REPORT</v-btn>              
				<v-btn @click.prevent="fncFilterProjectSalesReport" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
              <v-menu offset-y>
                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>
                      <a @click.prevent="fncExportProductSales">Export to CSV - No details</a>
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>
                      <a @click.prevent="fncExportProductSalesDetailed">Export to CSV - Detailed</a>
                    </v-list-tile-title>
                  </v-list-tile>                 
                </v-list>
              </v-menu>
			</v-flex>
		</v-layout>		
	</v-container>	
</template>

<script>
	import { mapGetters } from 'vuex';
  export default {
	name: 'RoleHeader',
    data () {
		return {			
			
		}		
	},
	methods: {
		fncFilterProductSalesReports() {
			var modalDetails = { title: 'Filter Report', component: 'modal-filter-product-sales-reports', mstate: true, params: {} };			
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
        fncExportProductSales() {
		    var objProducts = [];
		    for( var n in this.productSalesProducts ){
		        if( objProducts[this.productSalesProducts[n].range] == undefined ) {
                    objProducts[this.productSalesProducts[n].range] = [];
				}
                if( objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name] == undefined ) {
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name] = [];
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['quantity'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['gross'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['discount'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['nett'] = 0;
                }

                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['quantity'] += parseInt(this.productSalesProducts[n].quantity);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['gross'] += parseFloat(this.productSalesProducts[n].gross_total);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['discount'] += parseFloat(this.productSalesProducts[n].discount_total);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['nett'] += parseFloat(this.productSalesProducts[n].nett_total);
			}
			var reportData = 'RANGE/PRODUCT, QUANTITY, GROSS TOTAL, DISCOUNT TOTAL, NETT TOTAL' + "\n";
			for( var k in this.productSalesList ) {
				reportData += "\n" + this.productSalesList[k].name + ',,' + 'R' + this.productSalesList[k].gross.toFixed(2) + ',' + 'R' + this.productSalesList[k].discount.toFixed(2) + ',' + 'R' +this.productSalesList[k].nett.toFixed(2) + "\n\n";
				for( var n in objProducts[this.productSalesList[k].name]) {
				    var productName = n.replace(/<(?:.|\n)*?>/gm, '');
				    productName = productName.replace(/<br>/g, '');
				    productName = productName.replace(/,/g, '');
					productName = productName.replace(',', ' - ');
                    productName = productName.replace(/(?:\r\n|\r|\n)/g, ' - ');
                    reportData += productName + ',' + objProducts[this.productSalesList[k].name][n].quantity + ',' + 'R' +objProducts[this.productSalesList[k].name][n].gross.toFixed(2) + ',' + 'R' + objProducts[this.productSalesList[k].name][n].discount.toFixed(2) + ',' + 'R' + objProducts[this.productSalesList[k].name][n].nett.toFixed(2) + "\n";
				}
			}
			var reportDownload = document.createElement('a');
			reportDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(reportData));
			reportDownload.setAttribute('download', 'salesreport_basic.csv');
			reportDownload.click();
		},
        fncExportProductSalesDetailed() {

            var objProducts = [];
            for( var n in this.productSalesProducts ){
                if( objProducts[this.productSalesProducts[n].range] == undefined ) {
                    objProducts[this.productSalesProducts[n].range] = [];
                }
                if( objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name] == undefined ) {
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name] = [];
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['quantity'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['gross'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['discount'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['nett'] = 0;
                    objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['dates'] = [];
                }
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['quantity'] += parseInt(this.productSalesProducts[n].quantity);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['gross'] += parseFloat(this.productSalesProducts[n].gross_total);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['discount'] += parseFloat(this.productSalesProducts[n].discount_total);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['nett'] += parseFloat(this.productSalesProducts[n].nett_total);
                objProducts[this.productSalesProducts[n].range][this.productSalesProducts[n].product_name]['dates'].push(this.productSalesProducts[n]);
            }
            var reportData = 'DATE, QUOTE NO., QUOTE STATUS, QUOTE TENDER STATUS, ORIGINATOR, CUSTOMER, PROJECT, AVG. UNIT PRICE, QUANTITY, GROSS TOTAL, DISCOUNT TOTAL, NETT TOTAL' + "\n";
            for( var k in this.productSalesList ) {
                reportData += "\n" + this.productSalesList[k].name + ',' + ',,,,,,,,' + 'R' + this.productSalesList[k].gross.toFixed(2) + ',' + 'R' + this.productSalesList[k].discount.toFixed(2) + ',' + 'R' + this.productSalesList[k].nett.toFixed(2) + "\n\n";
                for( var n in objProducts[this.productSalesList[k].name]) {
                    var productName = n.replace(/<(?:.|\n)*?>/gm, '');
                    productName = productName.replace(/<br>/g, '');
                    productName = productName.replace(/,/g, '');
                    productName = productName.replace(',', ' - ');
                    productName = productName.replace(/(?:\r\n|\r|\n)/g, ' - ');
                    reportData += productName + ',,,,,,,,' + objProducts[this.productSalesList[k].name][n].quantity + ',' + 'R' + objProducts[this.productSalesList[k].name][n].gross.toFixed(2) + ',' + 'R' + objProducts[this.productSalesList[k].name][n].discount.toFixed(2) + ',' + 'R' + objProducts[this.productSalesList[k].name][n].nett.toFixed(2) + "\n";
                    for( var i in objProducts[this.productSalesList[k].name][n].dates ) {
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].date + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].quote_no + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].status + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].tender_status + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].originator_name + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].customer_name + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].project_name + ',';
                        reportData += parseFloat( objProducts[this.productSalesList[k].name][n].dates[i].gross_total / objProducts[this.productSalesList[k].name][n].dates[i].quantity ).toFixed(2) + ',';
                        reportData += objProducts[this.productSalesList[k].name][n].dates[i].quantity + ',';
                        reportData += 'R' + objProducts[this.productSalesList[k].name][n].dates[i].gross_total + ',';
                        reportData += 'R' + objProducts[this.productSalesList[k].name][n].dates[i].discount_total + ',';
                        reportData += 'R' + objProducts[this.productSalesList[k].name][n].dates[i].nett_total + "\n";
					}
                }
            }
            var reportDownload = document.createElement('a');
            reportDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(reportData));
            reportDownload.setAttribute('download', 'salesreport_detailed.csv');
            reportDownload.click();
        },
        fncFilterProjectSalesReport() {
          this.$store.commit('fncEmptyProductSalesList');
          this.$store.dispatch({
            type: 'fncPopulateProductSalesList',
            reload: true
          });
        }
	},
      computed: {
          ...mapGetters([
              'productSalesList',
			  'productSalesProducts',
          ])
      },
  }
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>